import { stateDesignationRequest } from "./stateDesignationRequest";

export default stateDesignationRequest;
